import {
  Sheet as ShadSheet,
  SheetContent as ShadSheetContent,
  SheetHeader as ShadSheetHeader,
  SheetTitle as ShadSheetTitle,
} from "@/components/ui/sheet"
import Button from "@/components/button"
import Bottombar from "@/components/bottombar"
import { Icon } from "@/icons/icon"
import { cn } from "@/lib/utils"
import { logout } from "@/services/auth"

export type LogoutConfirmSheetProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export default function LogoutConfirmSheet({
  open,
  onOpenChange,
}: LogoutConfirmSheetProps) {
  async function handleConfirm() {
    await logout()
  }

  function handleBack() {
    onOpenChange(false)
  }

  return (
    <ShadSheet open={open} onOpenChange={onOpenChange}>
      <ShadSheetContent
        side="bottom"
        className="shadow-drop-shadow mx-auto rounded-t-lg"
      >
        <ShadSheetHeader className="pb-0 sticky top-0 bg-white">
          <ShadSheetTitle className="text-xl font-semibold flex flex-col gap-5">
            <div className="h-13 w-13 flex items-center justify-center rounded-full bg-backdrop">
              <Icon name="Power" className="h-6 w-auto text-error" />
            </div>

            <div>Logout</div>
          </ShadSheetTitle>
        </ShadSheetHeader>

        <div className="font-normal pt-4 px-4 py-4">
          Are you sure you want to logout? Autosaved sheets will be available
          when you log back in.
        </div>

        <Bottombar className={cn("flex gap-4 bg-white sticky bottom-0")}>
          <Button variant="outline" onClick={handleBack}>
            Cancel
          </Button>
          <Button className="flex-1" variant="destructive" onClick={handleConfirm}>
            Logout
          </Button>
        </Bottombar>
      </ShadSheetContent>
    </ShadSheet>
  )
}
